// extracted by mini-css-extract-plugin
module.exports = {"item":"AccordionItem_item__TIUPl"};